import { useQuery } from '@tanstack/react-query';
import { CampaignsService } from '../services';
import { campaignsKeys } from '../queryKeys';
import { READ_ONLY_QUERY_OPTIONS } from '../queryConfig';

/**
 * One promo code for the detail page. A null result means "not found" (the
 * service maps a 404 to null); anything else that goes wrong surfaces via
 * isError, so callers must distinguish the two.
 */
export const usePromoCode = (campaignId) => {
  const { data, error, isError, isPending } = useQuery({
    queryKey: campaignsKeys.promoCode(campaignId),
    queryFn: () => CampaignsService.getPromoCode(campaignId),
    enabled: Boolean(campaignId),
    ...READ_ONLY_QUERY_OPTIONS,
  });

  return { promoCode: data ?? null, isPending, isError, error };
};
